import type { AxisScale } from '@visx/xychart';

import { isBandScale } from '../../../utils/scaleHelpers';
import { getScaleTypeConfig } from '../../scaleTypes';
import type { XScaleType } from '../../types/Scale';

import type { DomainCalculator } from './types';

/**
 * Factory for creating domain calculators based on scale type.
 *
 * Uses the unified SCALE_TYPE_REGISTRY - when adding a new scale type,
 * register it there (not here).
 *
 * Note: For band scales, we detect via isBandScale() which checks the actual
 * scale instance, ensuring correct behavior even if xScaleType doesn't match.
 */
export function createDomainCalculator(xScale: AxisScale, xScaleType: XScaleType): DomainCalculator {
  // Check actual scale type - band scales always use band calculator
  // This handles cases where the scale instance is band even if xScaleType says otherwise
  if (isBandScale(xScale)) {
    return getScaleTypeConfig('band').createDomainCalculator();
  }

  // Use the configured scale type for continuous scales
  const config = getScaleTypeConfig(xScaleType);
  return config.createDomainCalculator();
}
